import { Space, Typography } from 'antd'
import React from 'react'
import { MasterCardIcon, MasterCardIconWithFon, VisaCardIcon, VisaCardIconWithFon } from '@modules/CustomIcons';

function CardTypeInfo({ cardType, text }: { cardType: string; text: string }) {
     enum CardType {
      VISA = "Visa",
      MASTERCARD = "MasterCard"
    }
  return (
    <Space direction="horizontal">
 {
    cardType === CardType.VISA ?  <VisaCardIconWithFon /> :  <MasterCardIconWithFon/>
 }  
    <Typography.Text style={{ fontSize: '18px', fontWeight: 900 }}>
      {text}
    </Typography.Text>
  </Space>
  )
}

export default CardTypeInfo